import { ReactElement } from 'react';

export function formatArticleTip(text: string): ReactElement[] {
  const lines = text.split('\n');

  return lines
    .map((line, lineIndex) => {
      const parts: ReactElement[] = [];
      let key = 0;

      // Regular expression to match bold (__text__) and italic (*text*)
      const regex = /(__([^_]+)__|(\*([^*]+)\*))/g;
      let lastIndex = 0;
      let match;

      while ((match = regex.exec(line)) !== null) {
        if (match.index > lastIndex) {
          parts.push(<span key={key++}>{line.substring(lastIndex, match.index)}</span>);
        }
        if (match[2]) {
          parts.push(<strong key={key++}>{match[2]}</strong>);
        } else if (match[4]) {
          parts.push(<em key={key++}>{match[4]}</em>);
        }
        lastIndex = regex.lastIndex;
      }

      if (lastIndex < line.length) {
        parts.push(<span key={key++}>{line.substring(lastIndex)}</span>);
      }

      if (lineIndex < lines.length - 1) {
        parts.push(<br key={`br-${lineIndex}`} />);
      }

      return parts;
    })
    .flat();
}
